export default __webpack_public_path__ + "static/media/rocket_anim_54.382b224f.png";